// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.math.deg-per-rad.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.math.deg-per-rad.js
// module chunks = 4